import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const SET_TIERS = "SET_TIERS";
export const SET_SUBCONTRACTORS = "SET_SUBCONTRACTORS";
export const SET_CUSTOMERS = "SET_CUSTOMERS";
export const SET_CUSTOMER_SEARCH = "SET_CUSTOMER_SEARCH";
